// extracted by mini-css-extract-plugin
module.exports = {"topHeading":"styles_topHeading__7MRZg","keyContainer":"styles_keyContainer__yEPes","footerRight":"styles_footerRight__AyjeG","container":"styles_container__fLRO9"};